import * as React from 'react'
import { useState, useEffect } from 'react'
import {Form} from "react-bootstrap";

interface DisplayItemCalcSettingsProps {
    kedo: any
    item: any
    onChange: any
}

const DisplayItemCalcSettings: React.FC<DisplayItemCalcSettingsProps> = ({
    kedo,
    item,
    onChange
}) => {
    const [output, setOutput] = useState(item && item.settings && item.settings.output ? item.settings.output : null)

    return  <div>
        <Form.Group>
            <Form.Label>{kedo.t('Output')}</Form.Label>
            <Form.Control
                name={'output'}
                onChange={(e) => {
                    setOutput(e.target.value)
                    onChange('output', e.target.value)
                }}
                value={output}
                as={'select'}>
                <option value={''}>{kedo.t('Choose an option')}</option>
                <option value={'DATE'}>{kedo.t('Date')}</option>
                <option value={'DATETIME'}>{kedo.t('Datetime')}</option>
                <option value={'INTEGER'}>{kedo.t('Integer')}</option>
                <option value={'DECIMAL'}>{kedo.t('Decimal')}</option>
            </Form.Control>
        </Form.Group>
    </div>
}

export default DisplayItemCalcSettings
